/**
 * JSON Formatter Utilities
 *
 * Centralized utilities for consistent JSON serialization across the application.
 */

/**
 * Convert a value to pretty-printed JSON string with 2-space indentation Falls back to default value if input is
 * null/undefined
 *
 * @param value - Value to serialize
 * @param defaultValue - Fallback value if input is null/undefined (default: '{}')
 * @returns Pretty-printed JSON string
 */
export function toFormattedJson<T>(value: T, defaultValue: any = '{}'): string {
  return JSON.stringify(value ?? defaultValue, null, 2);
}

/**
 * Convert a value to compact JSON string (no whitespace)
 *
 * @param value - Value to serialize
 * @returns Compact JSON string
 */
export function toCompactJson<T>(value: T): string {
  return JSON.stringify(value);
}

export class JsonFormatter {
  static toFormattedJson = toFormattedJson;
  static toCompactJson = toCompactJson;
}
